//Config
import { NUMBER_OF_REQUEST } from "Config/config";

export default function FetchPlus(
  url,
  options = {},
  retries = NUMBER_OF_REQUEST
) {
  return fetch(url, options)
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw res.status;
      }
    })
    .catch((err) => {
      if (retries > 0) {
        return FetchPlus(url, options, retries - 1);
      }
      throw err;
    });
}
